import * as React from "react"
import Svg, { Path } from "react-native-svg"

const TriangleIcon = (props) => (
    <Svg
        width={32}
        height={21}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M31.031 11.452c.926-.297.926-1.607 0-1.904L1.555.093a1 1 0 0 0-1.305.953v18.908a1 1 0 0 0 1.305.953l29.476-9.455Z"
            fill={props.color}
        />
    </Svg>
)

export default TriangleIcon
